import { Injectable } from '@angular/core';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '../supported_locale';

@Injectable({ providedIn: 'root' })
export class I18nService {
  normalize(input: string | null | undefined): string {
    const fallback = DEFAULT_LOCALE;
    if (!input) {
      return fallback;
    }
    return (SUPPORTED_LOCALES as unknown as Array<string>).includes(input) ? input : fallback;
  }

  current(): string {
    const url = new URL(location.href);
    const paths = url.pathname.split('/').filter(Boolean);
    const urlLang = this.normalize(paths[0]);
    const stored = this.getLanguageFromLocalStorage(urlLang);
    return this.normalize(stored);
  }

  private getLanguageFromLocalStorage(language: string): string {
    const localLanguage = localStorage.getItem('CureSkin/language');
    if (localLanguage) {
      return localLanguage;
    }
    return language;
  }
}
